import type { GameProfile } from '../types';

const GREEN = '#2E7D32';
const RED = '#BC4435';
const BLACK = '#1c1c1c';

/** Standard European roulette red numbers. All other 1..36 are black. 0 is green. */
const ROULETTE_RED = new Set([
  1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36,
]);

export const roulette: GameProfile = {
  id: 'roulette',
  label: 'Roulette (0–36)',
  ballIds: Array.from({ length: 37 }, (_, i) => i), // 0..36
  colorFor: (id) => {
    if (id === 0) return GREEN;
    return ROULETTE_RED.has(id) ? RED : BLACK;
  },
  textureStyle: 'standard',
  machineCount: 1,
  resultsPerDraw: 1,
};
